import script from "./GeoGuesserGuess.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeoGuesserGuess.vue?vue&type=script&setup=true&lang=ts"

import "./GeoGuesserGuess.vue?vue&type=style&index=0&id=34619d98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34619d98"]])

export default __exports__